import { useEffectOnce } from 'react-use';
import { useCustomer } from '@app/user';
import { DOM } from '@app/utils';

/**
 *
 */
const useSetSelectedCurrency = () => {
  const customer = useCustomer();
  const defaultCurrency = customer?.defaultCurrency;

  useEffectOnce(() => {
    if (defaultCurrency) {
      DOM.forceSetCookie('stockx_selected_currency', defaultCurrency);
    }
  });
};

export default useSetSelectedCurrency;
